import {
  OrganizationMembersActiveRow,
  OrganizationMembersPendingRow,
  OrganizationMembersTableRow,
  isOrganizationMembersActiveRow,
  isOrganizationMembersPendingRow,
} from "@/types/organization-member";

export const isOrganizationMember = (
  item: NormalizedMemberData,
): item is NormalizedOrganizationMember => isOrganizationMembersActiveRow(item);

export const isWorkspaceInvite = (item: NormalizedMemberData): item is NormalizedGroupedInvite =>
  isOrganizationMembersPendingRow(item);

export type NormalizedOrganizationMember = OrganizationMembersActiveRow;
export type NormalizedGroupedInvite = OrganizationMembersPendingRow;
export type NormalizedMemberData = OrganizationMembersTableRow;
